// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Treasury (admin) — page layout + responsive.
 * Breakpoints (project standard): mobile <=576px, tablet 577–991px,
 * laptop 992–1280px, desktop >=1281px. Tables → cards is handled by
 * enterprise.css (.pro-table @ <=576px); this file owns page chrome only.
 */
.ent.treasury-page { padding: 24px; }
.ent.treasury-page .kpi-strip { margin: 16px 0; }
.ent.treasury-page .pro-table-wrap { margin-bottom: 16px; }

.ent.treasury-page .treasury-banner {
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  padding: 0.75rem 1rem;
  border-radius: var(--ent-radius);
  margin-bottom: 1rem;
  font-size: 0.875rem;
  line-height: 1.4;
}
.ent.treasury-page .treasury-banner.warn {
  background: var(--ent-amber-bg);
  border: 1px solid var(--ent-amber);
  color: var(--ent-amber);
}
.ent.treasury-page .treasury-banner strong { display: block; }

.ent.treasury-page .pro-table th.amount-cell svg { vertical-align: -2px; margin-right: 2px; }

.ent.treasury-page .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: var(--ent-muted);
  gap: 0.25rem;
}
.ent.treasury-page .empty-state svg { color: var(--ent-muted); margin-bottom: 0.5rem; }
.ent.treasury-page .empty-state p { margin: 0; font-weight: 600; color: var(--ent-text); }

@media (max-width: 768px) {
  .ent.treasury-page { padding: 16px; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/Treasury.css"],"names":[],"mappings":"AAAA;;;;;EAKE;AACF,qBAAqB,aAAa,EAAE;AACpC,gCAAgC,cAAc,EAAE;AAChD,qCAAqC,mBAAmB,EAAE;;AAE1D;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,uBAAuB;AACzB;AACA,6CAA6C,cAAc,EAAE;;AAE7D,mDAAmD,oBAAoB,EAAE,iBAAiB,EAAE;;AAE5F;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;AACA,sCAAsC,uBAAuB,EAAE,qBAAqB,EAAE;AACtF,oCAAoC,SAAS,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;;AAEzF;EACE,qBAAqB,aAAa,EAAE;AACtC","sourcesContent":["/*\n * Treasury (admin) — page layout + responsive.\n * Breakpoints (project standard): mobile <=576px, tablet 577–991px,\n * laptop 992–1280px, desktop >=1281px. Tables → cards is handled by\n * enterprise.css (.pro-table @ <=576px); this file owns page chrome only.\n */\n.ent.treasury-page { padding: 24px; }\n.ent.treasury-page .kpi-strip { margin: 16px 0; }\n.ent.treasury-page .pro-table-wrap { margin-bottom: 16px; }\n\n.ent.treasury-page .treasury-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.625rem;\n  padding: 0.75rem 1rem;\n  border-radius: var(--ent-radius);\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n  line-height: 1.4;\n}\n.ent.treasury-page .treasury-banner.warn {\n  background: var(--ent-amber-bg);\n  border: 1px solid var(--ent-amber);\n  color: var(--ent-amber);\n}\n.ent.treasury-page .treasury-banner strong { display: block; }\n\n.ent.treasury-page .pro-table th.amount-cell svg { vertical-align: -2px; margin-right: 2px; }\n\n.ent.treasury-page .empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  color: var(--ent-muted);\n  gap: 0.25rem;\n}\n.ent.treasury-page .empty-state svg { color: var(--ent-muted); margin-bottom: 0.5rem; }\n.ent.treasury-page .empty-state p { margin: 0; font-weight: 600; color: var(--ent-text); }\n\n@media (max-width: 768px) {\n  .ent.treasury-page { padding: 16px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
